export const ab_segment_durations = [
  { 'id': 1, 'name': '1 seconds segment duration' },
  { 'id': 2, 'name': '2 seconds segment duration' },
  { 'id': 3, 'name': '3 seconds segment duration' },
  { 'id': 4, 'name': '4 seconds segment duration' }
];

export const sd_bit_profiles = [
  { 'id': 8,  'name': '8 bits / 256 distinct WM',          'max': 255 },
  { 'id': 13, 'name': '13 bits / 8192 distinct WM',        'max': 8191 },
  { 'id': 16, 'name': '16 bits / 65536 distinct WM',       'max': 65535 },
  { 'id': 24, 'name': '24 bits / 16777216 distinct WM',    'max': 16777215 },
  { 'id': 32, 'name': '32 bits / 4294967296 distinct WM',  'max': 4294967295 }
];

export const ca_payload_sizes = [
  { 'id': 4,  'name': '4 bits / 16 distinct WM',               'max': 15 },
  { 'id': 8,  'name': '8 bits / 256 distinct WM',              'max': 255 },
  { 'id': 16, 'name': '16 bits / 65536 distinct WM',           'max': 65535 },
  { 'id': 24, 'name': '24 bits / 16777216 distinct WM',        'max': 16777215 },
  { 'id': 32, 'name': '32 bits / 4294967296 distinct WM',      'max': 4294967295 },
  { 'id': 48, 'name': '48 bits / 281474976710656 distinct WM', 'max': 281474976710655 }
];

export const densities = [
  { 'id': 10,  'name': '10'  },
  { 'id': 20,  'name': '20'  },
  { 'id': 30,  'name': '30'  },
  { 'id': 40,  'name': '40'  },
  { 'id': 50,  'name': '50'  },
  { 'id': 60,  'name': '60'  },
  { 'id': 70,  'name': '70'  },
  { 'id': 80,  'name': '80'  },
  { 'id': 90,  'name': '90'  },
  { 'id': 100, 'name': '100' }
];

export const sd_pm_modes = [
  { 'id': 0, 'name': 'off' },
  { 'id': 1, 'name': 'client-side' },
  { 'id': 2, 'name': 'flatness-based' }
];

/**
 * The DRM systems this form offers, and what the packager advertises when nothing says otherwise.
 *
 * The full `PROTECTION_SYSTEMS` vocabulary of the template, not a subset -- `Marlin` was dropped
 * from both sides, since nothing this platform delivers to licenses it and a job naming it shipped
 * an unplayable PSSH alongside the systems that did work. Adding a system is this list plus the
 * template's tuple.
 *
 * The order is the canonical one: the template re-sorts whatever it is given into this order, so
 * emitting the set in it keeps a stored PO comparable to what actually ran.
 *
 * Narrowing the set is not cosmetic. A delivery that does not license PlayReady should not
 * advertise a PlayReady PSSH -- a client that finds one and cannot get a licence for it fails
 * rather than falling through to a system it could have used.
 */
export const protection_systems = [
  {id: 'Widevine', name: 'Widevine', description: 'Android, Chrome, and most connected TVs.'},
  {id: 'PlayReady', name: 'PlayReady', description: 'Windows, Xbox, and many set-top boxes.'},
  {id: 'FairPlay', name: 'FairPlay', description: 'Safari, iOS, tvOS.'},
];

/** What the template advertises with no `protection_systems` key at all. */
export const default_protection_systems = ['Widevine', 'PlayReady', 'FairPlay'];

/**
 * The one watermark `vod-default-cmaf-abr-v2` implements, and the value the template's
 * `SUPPORTED_WATERMARKS` matches on.
 *
 * It replaced `stardust/sf`, which named the embedder (single-frame Stardust) rather than the
 * product. The settings that go with it travel in a `stardustmark` object of the same name, so the
 * key that switches the feature on and the key that configures it read the same.
 *
 * Content Armor A/B is not here: v1 carries it, reached through the Watermark PO flow. v2 does not
 * reject an unknown watermark silently -- it fails at render -- but it cannot embed one either.
 */
export const STARDUSTMARK = 'stardustmark';
